import moment from "moment";

export default class TaskModel {
  constructor() {
    this.name = "";
    this.initial_comment = "";
    this.end_comment = "";
    this.with_time = false;
    this.permits = [];
    this.position_ids = [];
    this.start_date = moment().format("YYYY-MM-DD");
    this.end_date = "";
    this.location_id = null;
    this.location_leader_id = null;
    this.crane = 0;
    this.coordination = 1;
  }
/* 
  reset() {
    Object.assign(this, new TaskModel());
  } */
}
